module.exports = __webpack_public_path__ + "img/9.0ec0d01f.png";